import {
  Card,
  Row,
  Col,
  Typography,
  Input,
  Select,
  Button,
  Divider,
  Form,
  Modal,
} from "antd";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import * as Apis from "../../../../utils/helper/enum";
import globalRequest from "../../../../utils/global/globalRequest";
import { changeLoader } from "../../../../redux/reducers/loader";

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const Wallet = ({ showWalletPopup, setShowWalletPopup, userId, getWalletBalance, getWalletBalanceHistory }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const vendorId = userId;

  const onFinish = async (values) => {
    const payload = {
      amount: values.amount,
      type: values.type,
      additional_note: values.additional_note,
    };

    dispatch(changeLoader(true));
    try {
      const response = await globalRequest(
        `${Apis.MANAGE_VENDOR.ADD_AMOUNT_IN_WALLET}/${vendorId}`,
        "PUT",
        payload,
        {},
        true
      );

      if (response?.data?.status === "SUCCESS") {
        toast.success("Amount added successfully");
        form.resetFields();
        setShowWalletPopup(false);
        getWalletBalance();
        getWalletBalanceHistory();
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setShowWalletPopup(false);
  };

  return (
    <Modal
      open={showWalletPopup}
      onCancel={handleCancel}
      footer={null}
      centered
      destroyOnClose
      width={600}
      maskStyle={{
        backdropFilter: "blur(6px)",
        backgroundColor: "rgba(0,0,0,0.45)",
      }}
    >
      <Card bordered={false}>
        <Title level={4}>Wallet Topup</Title>

        <Text type="secondary">
          Enter the amount below to add money in your wallet.
        </Text>

        <Divider />

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ type: "credit" }}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Amount"
                name="amount"
                rules={[
                  { required: true, message: "Please enter amount" },
                  {
                    validator: (_, value) =>
                      value > 0
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Please enter a valid amount")
                          ),
                  },
                ]}
              >
                <Input type="number" addonAfter="SAR" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Type" name="type" rules={[{ required: true }]}>
                <Select>
                  <Option value="credit">Credit</Option>
                  <Option value="debit">Debit</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Additional Notes"
            name="additional_note"
            rules={[{ required: true, message: "Please enter notes" }]}
          >
            <TextArea rows={4} placeholder="Write here..." />
          </Form.Item>

          <Divider />

          <Row justify="end" gutter={12}>
            <Col>
              <Button onClick={handleCancel}>Cancel</Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default Wallet;
